import { TCourse, TUserAuth } from "../../types";
import { Button } from "../../shared/button";
import { isAdmin, isDataOp } from "../../helpers/role";
import { API_URL } from "../../APIService";
import { useEffect, useState } from "react";
import CourseService from "../../APIService/CourseService";
import { c } from "vite/dist/node/moduleRunnerTransport.d-DJ_mE5sf";
import { Snackbar } from "@mui/material";
import { useSnackbar } from "notistack";
// import { HashLink } from "react-router-hash-link";

type TTaskHeaderProps = {
  course: TCourse;
  isClickedCheck: boolean;
  authInfo: TUserAuth;
};

function TaskHeader(props: TTaskHeaderProps) {
  const { course, authInfo, isClickedCheck } = props;
  const link = `/admin/course/edit/${course.id}`;
  const [text, setText] = useState("");
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    setText((isClickedCheck ? course.aTextBefore : course.qTextBefore) || "");
  });

  return (
    <div>
      <div>
        <h2
          className="TaskTaskTitle"
          dangerouslySetInnerHTML={{ __html: course.header1 }}
        />
        {isAdmin(authInfo.role) || isDataOp(authInfo.role) ? (
          <Button
            className="TaskEditLink"
            onClick={() => window.open(link, "_blank")}
          >
            Редактировать
          </Button>
        ) : null}
        &nbsp;
        {isAdmin(authInfo.role) ? (
          <Button
            className="TaskEditLink"
            onClick={async () => {
              const newId = await CourseService.duplicateCourse(course.id);
              enqueueSnackbar(
                `Копия курса ${course.id} создана. Новый курс - ${newId}`,
                {
                  variant: "success",
                  anchorOrigin: { horizontal: "right", vertical: "top" },
                },
              );
              setTimeout(
                () => window.open(`/admin/course/edit/${newId}`, "_blank"),
                2000,
              );
            }}
          >
            Создать копию курса
          </Button>
        ) : null}
      </div>
      <div className="TaskText">
        <p className="TaskText" dangerouslySetInnerHTML={{ __html: text }} />
        {/* <HashLink to={"/exam#239 ФМЛ (5 класс)"}>рабочий линк</HashLink> */}
        {!isClickedCheck && course.image ? (
          <p style={{ textAlign: "center" }}>
            <img src={API_URL + "image" + course.image} alt={course.image} />
          </p>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default TaskHeader;
